import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
	SubmissionDetailsComponent,
	MailInThanksComponent,
} from "../components";
import { InstantValidationCodes } from "../components/Thanks/InstantValidationCodes";
import { ThankYouSection, Button } from "../components/styled";
import { AppContext } from "../components/context/AppContext";
import {
	createMarkup,
	getOfferConfig,
	pushToHistory,
	identifyOffer,
} from "../utils/Helpers";
import { ROUTE_PATHS } from "../utils/routes";
import offerIds from "../utils/offerIds";
import AnalyticsService from "../utils/AnalyticsService";

const { AAA_OFFERID } = offerIds;

export const Thanks = ({ history }) => {
	let submissionAlreadyExists = false;
	let overrideThanksText = "";
	const { state, dispatch } = useContext(AppContext);

	useEffect(() => {
		AnalyticsService.sendUniquePageview(ROUTE_PATHS.THANKS);
		dispatch({ type: "SETTHANKYOUTEXT" });
	}, [dispatch]);

	if (!history.location.state) {
		submissionAlreadyExists = false;
	} else if (history.location.state.submissionExists) {
		submissionAlreadyExists = history.location.state.submissionExists;
	}

	if (!state.campaign.crossDupeCheck) {
		state.campaign.thankYouText =
			state.campaign.dupeCheckErrorMessage +
			"<br><br><br><br> <br><br><br><br> <br><br><br><br>";
	}

	if (submissionAlreadyExists && state.campaign.secondThankYouText) {
		overrideThanksText = state.campaign.secondThankYouText;
	}

	const {
		thankYouText,
		thankYouTextTwo,
		offerFormUrl,
		offerId,
		thankYouImage,
		thankYouImageMob,
		secondThankYouText,
	} = state.campaign;

	const thankYouTextStyle = {
		maxWidth: "500px",
	};

	const offerIs = { ...identifyOffer(offerId) };
	const offerConfig = getOfferConfig(offerIs);

	const instantValidationOffer = state.iSubmission.instantValidationResult;
	const instantValidationError =
		state.iSubmission.instantValidationResult &&
		state.iSubmission.submissionErrors &&
		state.iSubmission.submissionErrors.length > 0;

	const displaySubmission = () => {
		if (!state.campaign.crossDupeCheck) {
			offerConfig.addressVisible = false;
			offerConfig.showNewSubmissionButton = false;
		} else {
			if (
				!offerIs.isOomaOffer &&
				!offerIs.isParamountOffer &&
				!offerIs.isAaaOffer
			) {
				return (
					<SubmissionDetailsComponent
						submission={state.iSubmission}
						addressVisible={offerConfig.addressVisible}
					/>
				);
			} else {
				return null;
			}
		}
	};

	return (
		<ThankYouSection
			offerIs={offerIs}
			useThankyouImage={thankYouImage}
			useThankyouImageMob={thankYouImageMob}
		>
			<div
				className={`container-fluid ${
					offerIs.isTVisionOffer ? "hero2-alt" : "hero2"
				}`}
        id="announce" tabIndex="-1" autoFocus aria-live="polite"	
			>
				<div className="row" 
			>
					<div 	role="alert" className={offerIs.isSiriusXmOffer ? "container mx-auto sirius-sorry":"container mx-auto"} >
				
						{state.choseMailIn ? (
							<MailInThanksComponent offerFormUrl={offerFormUrl} />
						) : (
							<>
								<h1 role="alert" 
									
									className={offerIs.isParamountOffer ? "p-paramount" : " "}
								>
									Thanks.
								</h1>

								{thankYouText !== "" ? (
									<p
										style={thankYouTextStyle}
										dangerouslySetInnerHTML={createMarkup(thankYouText)}
									></p>
								) : (
									"Thank you!"
								)}

								{state.campaign.crossDupeCheck &&
									instantValidationOffer &&
									!instantValidationError &&
									thankYouTextTwo &&
									overrideThanksText.length < 1 && (
										<p
											className={offerIs.isParamountOffer ? "p-paramount" : ""}
											style={thankYouTextStyle}
											dangerouslySetInnerHTML={createMarkup(thankYouTextTwo)}
										></p>
									)}
								{state.campaign.crossDupeCheck &&
									instantValidationOffer &&
									!instantValidationError &&
									overrideThanksText.length > 0 && (
										<p
											className={offerIs.isParamountOffer ? "p-paramount" : ""}
											style={thankYouTextStyle}
											dangerouslySetInnerHTML={createMarkup(secondThankYouText)}
										></p>
									)}

								{state.campaign.crossDupeCheck &&
									!instantValidationOffer &&
									thankYouTextTwo &&
									!offerIs.isAaaOffer && (
										<p
											className={offerIs.isParamountOffer ? "p-paramount" : ""}
											style={thankYouTextStyle}
											dangerouslySetInnerHTML={createMarkup(thankYouTextTwo)}
										></p>
									)}

								{instantValidationError && (
									<>
										<p className={offerIs.isSiriusXmOffer ? "sirius-sorry-details":" "} >
											<strong>
												Sorry, it appears your account is ineligible for this
												promotion. Your denial reason is:
											</strong>
											<ul>
												{state.iSubmission.submissionErrors.map((error) => (
													<li
														key={error.description || error.nonCompMessage}
													>
														<strong>
															{!instantValidationOffer
																? error.description
																: error.nonCompMessage}
														</strong>
													</li>
												))}
											</ul>
										</p>
										<br />
										<br />
									</>
								)}
								<InstantValidationCodes offerIs={offerIs} history={history} />

								{displaySubmission()}
							</>
						)}
						{offerConfig.showNewSubmissionButton ? (
							<div  className="pt-3">
								<Button
									className="btn"
									onClick={() => {
										return offerId === AAA_OFFERID
											? pushToHistory(history, ROUTE_PATHS.AAA)
											: pushToHistory(history, ROUTE_PATHS.DASHBOARD);
									}}
									primary
								>
									Start new submission
								</Button>
							</div>
						) : null}

						{offerIs.isGoogleHintOffer && (
							<p>Google and Nest Wifi are trademarks of Google LLC</p>
						)}
						</div>
					</div>
				</div>
		</ThankYouSection>
	);
};

Thanks.propTypes = {
	history: PropTypes.object,
};

Thanks.requiresAuth = true;
